import React from 'react'
import { useState } from "react";
import { css } from "@emotion/react";
import RingLoader from "react-spinners/RingLoader";
import Box from '@mui/material/Box';
import {Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import {useSelector} from 'react-redux'

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const styleSpinner = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 2000,
  boxShadow: 0,
  p: 100,
};

function LoadingComponent() {

  const stateLoading = useSelector(store => store.AppState.loading)

  let [loading, setLoading] = useState(stateLoading);
  let [color, setColor] = useState("#D0D736");
  const [openModal, setOpenModal] = React.useState(stateLoading);

  React.useEffect(() => {
    setLoading(stateLoading)
    setOpenModal(stateLoading)
  })

  return (
    <Modal
    open={openModal}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    >  
    <Box sx={styleSpinner}>
      <div className="">
        <RingLoader color={color} loading={loading} css={override} size={160} />
        <Typography id="modal-modal-title" variant="h6" component="h2">
          <center>Procesando datos.....</center>
        </Typography>
      </div>
    </Box>
    </Modal>
  );
}

export default LoadingComponent;
